import apiService from '../../../services/api-client';
import { LocationReportResponse } from '../../../interfaces/location-report.interface';

export const locationReportApiService = {
    getLocationsReport: async (companyId: number): Promise<LocationReportResponse> => {
        const { data } = await apiService().get<LocationReportResponse>(`company/${companyId}/locations/report`);
        return data;
    },
}; 